import React from 'react';

import Image from '../../library/image/image';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import SnowAccelerationChart from './components/snow-acceleration-chart/snow-acceleration-chart';
import CirclesRating, {
  FilledCircleColor
} from '../circles-rating/circles-rating';

import useMediaQuery from '../../shared/hooks/use-media-query/use-media-query';

import { Maybe } from '../../shared/types/graphql-types';

import './snow-acceleration-info.scss';

interface SnowAccelerationInfoProps {
  accelerationRating?: number;
  accelerationSeconds: number;
  accelerationTitle?: Maybe<string>;
  accelerationTooltipText?: Maybe<string>;
  className?: string;
}

function SnowAccelerationInfo(props: SnowAccelerationInfoProps) {
  const {
    accelerationRating,
    accelerationSeconds,
    accelerationTitle,
    accelerationTooltipText,
    className = ''
  } = props;

  const { isMinLg } = useMediaQuery();
  const showAccelerationRating = Number(accelerationRating) > 0;

  return (
    <div className={`snow-acceleration-info ${className}`}>
      <div styleName="title">
        <div>
          <Image
            alt="Acceleration Icon"
            height="20"
            src="https://discounttire.scene7.com/is/content/discounttire/treadwell/treadwell_ic_acceleration.svg"
            styleName="icon"
            width="20"
          />
          <Typography weight="heavy">
            {accelerationTitle || 'Snow Acceleration'}
          </Typography>
          {accelerationTooltipText && (
            <Tooltip content={accelerationTooltipText} styleName="tooltip" />
          )}
        </div>
        {showAccelerationRating && (
          <div styleName="circles-rating-container">
            <CirclesRating
              filledCircleColor={FilledCircleColor.GREY}
              rating={Number(accelerationRating)}
            />
            {accelerationRating!.toFixed(1)}
          </div>
        )}
      </div>
      <div>
        <SnowAccelerationChart
          bottomOffset={isMinLg ? 8 : 0}
          value={accelerationSeconds}
        />
      </div>
    </div>
  );
}

export default SnowAccelerationInfo;
